import { render, staticRenderFns } from "./AdventureTourLeaderboard.vue?vue&type=template&id=6c04d682&scoped=true&"
import script from "./AdventureTourLeaderboard.vue?vue&type=script&lang=ts&"
export * from "./AdventureTourLeaderboard.vue?vue&type=script&lang=ts&"
import style0 from "./AdventureTourLeaderboard.vue?vue&type=style&index=0&id=6c04d682&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c04d682",
  null
  
)

export default component.exports